import { Separator } from "@/shared/components/ui/separator";
import { BreadcrumbsToBasedata } from "@/shared/service-manager/default-ui/base-data-page/breadcrumbs-to-basedata";
import {
  NavigationGroup,
  ProcessPage,
  ProcessPageMain,
  ProcessPageMainContent,
  ProcessPageMainHeader,
  ProcessPageSidebar,
  ProcessPageSidebarNavigation,
  ProcessSidebarTrigger,
} from "@/shared/service-manager/default-ui/process-page/process-page";
import {
  AirVent,
  Building2,
  CircleX,
  LockKeyhole,
  PackageOpen,
  Pipette,
  UsersRound,
} from "lucide-react";
import { Outlet } from "react-router";

export default function BaseDataRoute() {
  return (
    <ProcessPage>
      <ProcessPageSidebar className="pt-16">
        <ProcessPageSidebarNavigation groups={sidebarNavigation} />
      </ProcessPageSidebar>
      <ProcessPageMain>
        <ProcessPageMainHeader className="justify-between">
          <div className="flex items-center gap-2">
            <ProcessSidebarTrigger />
            <Separator orientation="vertical" className="mr-2 h-4" />
            <BreadcrumbsToBasedata />
          </div>
        </ProcessPageMainHeader>
        <ProcessPageMainContent>
          <Outlet />
        </ProcessPageMainContent>
      </ProcessPageMain>
    </ProcessPage>
  );
}

const sidebarNavigation: NavigationGroup[] = [
  {
    label: "Stammdaten",
    items: [
      {
        label: "Unternehmen",
        icon: Building2,
        to: "companies",
      },
      {
        label: "Kunden",
        icon: UsersRound,
        to: "customers",
      },
      {
        label: "Authorisierung",
        icon: LockKeyhole,
        to: "feature-auth",
      },
      {
        label: "Probenfehler",
        icon: CircleX,
        to: "sample-errors",
      },
      {
        label: "Schimmelpilze",
        icon: Pipette,
        to: "moulds",
      },
      {
        label: "Chargen",
        icon: PackageOpen,
        to: "batches",
      },
      {
        label: "Luftkeimsammler",
        icon: AirVent,
        to: "airsamplers",
      },
    ],
  },
];
